export enum ViewerMode {
	DEFAULT = "default",
	PREVIEW = "preview",
	PAGE = "page",
	ATTACHMENT = "attachment",
	PORTFOLIO = "portfolio",
	PORTFOLIO_PREVIEW = "portfolio_preview",
	PORTFOLIO_PAGE = "portfolio_page",
}